import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';

export default class CommonUtils {
    static generateToken(secManager) {
        // let localStorage = window.localStorage;

        let SecurityManager = secManager;
        if (!SecurityManager.key) {
            throw 'Key not present';
        }

        let token, hash, timestamp, message, info, plain;

        if (!SecurityManager.key) {
            //dispatch('logOut');
        }

        timestamp = moment().valueOf();

        // Construct the hash body by concatenating the userAgent, username, app_id, app_version.
        message = [
            navigator.userAgent.replace(/:/g, ""),
            process.env.app_id,
            process.env.version,
            SecurityManager.username,
            timestamp,
        ].join(':');

        // Hash the message, using the key.
        hash = CryptoJS.HmacSHA256(message, SecurityManager.key);

        // Base64-encode the hash to get the resulting token.
        token = CryptoJS.enc.Base64.stringify(hash);
        plain = [
            navigator.userAgent.replace(/:/g, ""),
            process.env.app_id,
            process.env.version,
            SecurityManager.username,
            timestamp,
            '',
            '',
            '',
            '',
        ].join(':');

        info = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(plain));

        return {
            token: token,
            info: info,
            message: message,
            plain: plain,
            hashed_password: SecurityManager.key
        };
    }

    static hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
    }


    static generateUUID() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
    }

    static sortFunction(arrayToSort, sortType, sortBy) {
        return arrayToSort.sort(function (a, b) {
            if (a[sortBy] < b[sortBy]) {
                return sortType === 'asc' ? -1 : 1;
            }
            if (a[sortBy] > b[sortBy]) {
                return sortType === 'asc' ? 1 : -1;
            }
            return 0;

        })
    }

    static groupBy(arrayToGroup, fieldToUse) {
        let objectToGroup = {}
        arrayToGroup.forEach(item => {
            if (objectToGroup[item[fieldToUse]]) {
                objectToGroup[item[fieldToUse]].push(item)
            } else {
                objectToGroup[item[fieldToUse]] = [item]
            }
        })
        return objectToGroup
    }

    static  clearCookies() {
        let cookies = document.cookie.split('; ')
        for (let c = 0; c < cookies.length; c++) {
            let d = window.location.hostname.split('.')
            while (d.length > 0) {
                let cookieBase = encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path='
                let p = window.location.pathname.split('/')
                document.cookie = cookieBase + '/'
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/')
                    p.pop()
                }

                d.shift()
            }
        }
    }

    static getCookie(name) {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=')
            return parts[0] === name ? decodeURIComponent(parts[1]) : r
        }, '')
    }

}
